<template>
    <div class="w-full shrink-0 px-2 pb-2 md:mx-auto md:max-w-(--breakpoint-md) md:px-4">
        <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <BaseButton theme="neutral" class="w-full justify-center rounded-lg sm:w-auto" :disabled="disabled" :aria-label="keepEditingAriaLabel" @click="emit('keep-editing')">
                {{ keepEditingLabel ?? t("chat.developmentGoal.actions.keepEditing") }}
            </BaseButton>
            <BaseButton ref="lockInButton" theme="primary" class="w-full justify-center sm:w-auto" :disabled="disabled" :aria-label="lockInAriaLabel" @click="emit('lock-in')">
                {{ lockInLabel ?? t("chat.developmentGoal.actions.lockIn") }}
            </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

withDefaults(defineProps<{ disabled?: boolean; keepEditingLabel?: string; lockInLabel?: string; keepEditingAriaLabel?: string; lockInAriaLabel?: string }>(), {
    disabled: false,
    keepEditingLabel: undefined,
    lockInLabel: undefined,
});
const emit = defineEmits<{ "keep-editing": []; "lock-in": [] }>();
const { t } = useI18n();

const lockInButton = useTemplateRef<InstanceType<typeof BaseButton>>("lockInButton");
defineExpose({ focusLockIn: () => (lockInButton.value?.$el as HTMLButtonElement | undefined)?.focus() });
</script>
